/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to create a new note
 * @export
 * @interface CreateNoteCommand
 */
export interface CreateNoteCommand {
    /**
     * Title of the note
     * @type {string}
     * @memberof CreateNoteCommand
     */
    title: string;
    /**
     * Content/body of the note
     * @type {string}
     * @memberof CreateNoteCommand
     */
    content?: string | null;
    /**
     * Due date — date CALENDAIRE ("yyyy-MM-dd" en envoi, ISO sans Z en lecture), jamais de conversion de fuseau
     * @type {string}
     * @memberof CreateNoteCommand
     */
    dueDate?: string | null;
    /**
     * Priority referential ID
     * @type {string}
     * @memberof CreateNoteCommand
     */
    priorityId: string;
    /**
     * Status referential ID
     * @type {string}
     * @memberof CreateNoteCommand
     */
    statusId: string;
    /**
     * Risk ID to link this note to
     * @type {string}
     * @memberof CreateNoteCommand
     */
    riskId?: string | null;
    /**
     * Person ID to link this note to
     * @type {string}
     * @memberof CreateNoteCommand
     */
    personId?: string | null;
    /**
     * List of tag IDs to associate with the note
     * @type {Array<string>}
     * @memberof CreateNoteCommand
     */
    tagIds?: Array<string>;
    /**
     * List of person IDs to mention in the note
     * @type {Array<string>}
     * @memberof CreateNoteCommand
     */
    mentionPersonIds?: Array<string>;
    /**
     * List of attachment file IDs to associate with the note
     * @type {Array<string>}
     * @memberof CreateNoteCommand
     */
    attachmentIds?: Array<string>;
}

/**
 * Check if a given object implements the CreateNoteCommand interface.
 */
export function instanceOfCreateNoteCommand(value: object): value is CreateNoteCommand {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('priorityId' in value) || value['priorityId'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    return true;
}

export function CreateNoteCommandFromJSON(json: any): CreateNoteCommand {
    return CreateNoteCommandFromJSONTyped(json, false);
}

export function CreateNoteCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNoteCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'dueDate': json['dueDate'] == null ? undefined : json['dueDate'],
        'priorityId': json['priorityId'],
        'statusId': json['statusId'],
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'personId': json['personId'] == null ? undefined : json['personId'],
        'tagIds': json['tagIds'] == null ? undefined : json['tagIds'],
        'mentionPersonIds': json['mentionPersonIds'] == null ? undefined : json['mentionPersonIds'],
        'attachmentIds': json['attachmentIds'] == null ? undefined : json['attachmentIds'],
    };
}

export function CreateNoteCommandToJSON(json: any): CreateNoteCommand {
    return CreateNoteCommandToJSONTyped(json, false);
}

export function CreateNoteCommandToJSONTyped(value?: CreateNoteCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'content': value['content'],
        'dueDate': value['dueDate'],
        'priorityId': value['priorityId'],
        'statusId': value['statusId'],
        'riskId': value['riskId'],
        'personId': value['personId'],
        'tagIds': value['tagIds'],
        'mentionPersonIds': value['mentionPersonIds'],
        'attachmentIds': value['attachmentIds'],
    };
}

